import React from 'react';
import { getCurrency } from 'globals/utils';
import FsBody from 'ui-elements/typography/FsBody';
import { Classes } from '@material-ui/styles/mergeClasses/mergeClasses';

interface FsCurrencyProps {
  currency?: string;
  format?: string;
  classes?: Classes;
}

const FsCurrency: React.FC<FsCurrencyProps> = ({
  currency,
  format,
  children,
  classes,
}) => {
  return (
    <FsBody className={classes?.root}>
      {getCurrency({
        currency,
        format,
        value: typeof children === 'number' ? children : 0,
      })}
    </FsBody>
  );
};

export default FsCurrency;
